import { FC, ReactNode } from 'react';
import { Stack, StackItem } from '@fluentui/react';
import { MenuGroup, Tooltip } from '@fluentui/react-components';
import { ChevronDoubleRight16Filled, ChevronDoubleLeft16Filled } from '@fluentui/react-icons';
import { hands, IconColor, inlineSideMenu, sideBarInline } from '../../styles/customStyles';

interface iSideMenus {
  setleftOpenSubMenu: (state: boolean) => void;
  leftOpenSubMenu: boolean;
  menuItems: ReactNode;
};

export const SideMenu: FC<iSideMenus> = ({ setleftOpenSubMenu, leftOpenSubMenu, menuItems }) => {
  const handleClick = () => { setleftOpenSubMenu(!leftOpenSubMenu) };
  sessionStorage.setItem("leftOpenSubMenu", `${leftOpenSubMenu}`)
  const iconData = (
    <Stack tokens={{ padding: 8 }}>
      <Tooltip withArrow relationship="label" positioning="below" content={leftOpenSubMenu ? "Hide" : "Show"}>
        {leftOpenSubMenu
          ? <ChevronDoubleLeft16Filled style={hands} onClick={handleClick} {...IconColor} />
          : <ChevronDoubleRight16Filled style={hands} onClick={handleClick} />}
      </Tooltip>
    </Stack>
  );
  return (
    <MenuGroup style={{ ...leftOpenSubMenu ? sideBarInline : {} }}>
      <Stack horizontal horizontalAlign="space-between" style={{ ...leftOpenSubMenu ? { width: '210px' } : {} }}>
        <StackItem style={{ ...inlineSideMenu, maxWidth: '175px' }}> {leftOpenSubMenu ? menuItems : iconData} </StackItem>
        <StackItem style={{ position: "absolute", marginLeft: 175 }}> {leftOpenSubMenu && iconData} </StackItem>
      </Stack>
    </MenuGroup>
  );
};
